// extracted by mini-css-extract-plugin
module.exports = {"container":"HomeShortCutItem_container__UwnXm","image":"HomeShortCutItem_image___xhGI","brandType":"HomeShortCutItem_brandType__8zfYe","title":"HomeShortCutItem_title__Li__w"};